export default __webpack_public_path__ + "static/media/Featured-1.610874e6.jpg";